import gql from 'graphql-tag';

export const registerUserQuery = gql`
  query registerUserQuery {
    allLicenses {
      _id
      name
    }
    allLanguages {
      _id
      name
    }
    allCountries {
      _id
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/qql-shared/queries.js